import { Coord } from "../../../../../../../src/types/Interface";


export default function calcBgCorners(shapeCoords: Coord[], pivotCoord: Coord, cellSize: number){
  const sortedX = [...shapeCoords, pivotCoord].sort((a, b) => a.x - b.x);
  const sortedY = [...shapeCoords, pivotCoord].sort((a, b) => a.y - b.y);
    
  const minCoord = {
    x: sortedX[0].x - 2 * cellSize,  
		y: sortedY[0].y - 2 * cellSize 
  }

  const maxCoord = {
    x: sortedX[sortedX.length - 1].x + 2 * cellSize,
    y: sortedY[sortedY.length - 1].y + 2 * cellSize
  }
	return  [
      { x: minCoord.x, y: minCoord.y },
      { x: maxCoord.x, y: minCoord.y },
      { x: maxCoord.x, y: maxCoord.y },
      { x: minCoord.x, y: maxCoord.y }
    ];
}